import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=292f1d3f&scoped=true&"
import script from "./Play.vue?vue&type=script&lang=ts&"
export * from "./Play.vue?vue&type=script&lang=ts&"
import style0 from "./Play.vue?vue&type=style&index=0&id=292f1d3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292f1d3f",
  null
  
)

export default component.exports